<template>
  <div>
    <b-card
      v-for="site in sites"
      class="mb-3"
      :key="site.id"
      :title="site.project.course"
      :sub-title="
        `${site.project.id}:
      ${site.extendedProperties.developer_lastname}`
      "
    >
      <b-table
        :items="[site.extendedProperties]"
        class="pt-2"
        stacked="md"
        :fields="fields"
      >
        <template v-slot:cell(id)="data">
          <b-link :to="`/projects/${data.value}/?caller=collection`">
            <b-icon icon="link45deg"></b-icon>
          </b-link>
        </template>
      </b-table>
      <div>
        <b-list-group :flush="siteDetailsFlush">
          <b-list-group-item
            ><strong>Developer information</strong><br />
            <ul class="developer-info">
              <li v-for="developer in site.contracts" :key="developer.id">
                {{ developer.full_name }},
                <em><span v-html="formatEmplid(developer.emplid)"></span></em>
                &nbsp;
                <b-link :href="`mailto:${developer.email_address}`">
                  <i class="far fa-envelope"></i>
                </b-link>
              </li>
            </ul>
          </b-list-group-item>
          <b-list-group-item
            ><strong>Use program template</strong><br />
            <p v-if="site.project.use_template">Yes</p>
            <p v-else>No</p>
          </b-list-group-item>
          <b-list-group-item
            ><strong>OFDIT notes</strong><br />
            <p class="para-white-space">
              {{ site.extendedProperties.ofdit_notes }}
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
      <GCreateDevSitesForm :site="site" />
    </b-card>
  </div>
</template>

<script>
  import GCreateDevSitesForm from '@/components/GCreateDevSitesForm.vue'

  export default {
    name: 'GCreateDevSites',
    components: {
      GCreateDevSitesForm
    },
    data() {
      return {
        siteDetailsFlush: true,
        fields: [
          {
            key: 'id',
            label: 'Project Record'
          },
          {
            key: 'course_title',
            label: 'Title'
          },
          {
            key: 'course_duration',
            label: 'Duration'
          },
          {
            key: 'ofdit_lead',
            label: 'OFDIT lead'
          },
          {
            key: 'tags',
            label: 'Tags'
          },
          {
            key: 'cohort',
            label: 'Cohort'
          }
        ]
      }
    },
    async created() {
      await this.$store.dispatch('getProjects')
      await this.$store.dispatch('getContracts')
      await this.$store.dispatch('getDevSitesToBeCreated')
    },
    computed: {
      sites() {
        return this.$store.state.courseDev.devSitesToBeCreated.map(site => {
          return {
            project: site,
            extendedProperties: this.$store.state.courseDev.projects.filter(
              project => project.id === site.id
            )[0],
            contracts: this.$store.state.courseDev.contracts.filter(
              contract => contract.project_id === site.id
            )
          }
        })
      }
    },
    methods: {
      formatEmplid(emplid) {
        const re = /\d{8}/
        if (re.test(emplid)) {
          return emplid
        } else {
          return '<i class="far fa-sad-tear">'
        }
      }
    }
  }
</script>

<style scoped>
  .developer-info {
    padding-left: 0;
    list-style-type: none;
  }

  .para-white-space {
    white-space: pre-line;
  }
</style>
